module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/1@2x_548d65e734c2ae17b2fb8d4e389cd70b.png";